import { setCookie } from "cookies-next";
import { useEffect } from "react";

export function useUserId(userId: string | undefined, isLoggedIn: boolean) {
  useEffect(() => {
    if (userId && isLoggedIn) {
      setCookie("kz_user_id", userId, {
        path: "/",
        expires: new Date(
          new Date().setFullYear(new Date().getFullYear() + 10),
        ),
        sameSite: "lax",
        domain: process.env["NEXT_PUBLIC_COOKIE_DOMAIN"],
      });
    }
  }, [userId, isLoggedIn]);

  return {};
}
